'use strict';

var Sugar = require('sugar-core');

require('./build/buildRelativeAliasesCall');

module.exports = Sugar.Date.isFriday;


// WEBPACK FOOTER //
// ./~/sugar-date/date/isFriday.js